export default __webpack_public_path__ + "static/media/Bloodregent Claymore.23e87997.jpg";